module.exports = __webpack_public_path__ + "static/media/share.e2438c88.svg";